import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { InvoiceSchema } from '../base/invoice.js';
export const CheckInvoicePreReqsRequestSchema = z.object({
    invoice: InvoiceSchema.pick({ total: true, customer: true }),
    entityId: CornSchema,
    additional: z.record(z.string(), z.unknown()).optional(),
});
export const CheckInvoicePreReqsResponseSchema = z.object({
    result: z.boolean(),
    reasons: z.string().array().optional(),
});
